export default "__VITE_ASSET__4QhoOwYv__"